import { createFileUploadStore, type FileUploadStore } from '@sib/files';

export type { FileUploadStore };

export const useTicketFileUploadStore = createFileUploadStore();

export const useFileManagerFileUploadStore = createFileUploadStore();
